/*
  Ad countdown offer. Settings, text and styles: sections/ad-offer.liquid

  Someone who lands with ?offer=CODE (CODE set up as an Offer block) gets a countdown.
  - The end time is saved in localStorage, so leaving and coming back doesn't reset it,
    and tapping the ad again doesn't restart it.
  - The code is put on the cart when the countdown starts and taken off when it ends
    (or on their next page view, if it ran out while they were away).
  - While it runs: the announcement bar shows the countdown, the plant page shows the offer price,
    and the cart shows the time left.
  - On an unpublished theme preview, &offer_reset=1 starts the countdown over.
*/
(function () {
  'use strict';

  if (window.RaizAdOffer) return;

  var configEl = document.getElementById('AdOfferConfig');
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (error) {
    return;
  }

  var STORAGE_KEY = 'raiz-ad-offer';
  var TICK_MS = 250;
  var URGENT_MS = 60 * 1000;
  var CLOCK_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="13" r="7.5"/><path d="M12 9.5V13l2.5 1.6M9.5 3h5"/></svg>';

  var text = config.text || {};
  var pageProduct = config.product || null;
  var ui = { bar: null, barText: null, lastLabel: '', lastPrice: null, urgent: false, timer: null };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var isPreview = Boolean(
    window.Shopify &&
      (window.Shopify.designMode || (window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main'))
  );

  var offers = {};
  (config.offers || []).forEach(function (offer) {
    var code = String((offer && offer.code) || '')
      .trim()
      .toUpperCase();
    if (!code) return;
    offers[code] = {
      code: code,
      percent: Number(offer.percent) || 0,
      minutes: Number(offer.minutes) || 5,
      product: offer.product || null,
    };
  });

  function noop() {}
  function now() {
    return Date.now();
  }

  /* ---------- Saved state ---------- */

  var memoryState = null;

  function readState() {
    var saved = null;
    try {
      saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
    } catch (error) {
      saved = memoryState;
    }
    if (!saved || typeof saved !== 'object' || !saved.offers || typeof saved.offers !== 'object') {
      saved = { active: null, offers: {} };
    }
    return saved;
  }

  function writeState() {
    memoryState = state;
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (error) {}
  }

  /* ---------- Formatting ---------- */

  function formatLeft(ms) {
    var total = Math.max(0, Math.ceil(ms / 1000));
    var minutes = Math.floor(total / 60);
    var seconds = total % 60;
    return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
  }

  function delimit(numberString, thousands, decimal) {
    var parts = numberString.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
  }

  function formatMoney(cents) {
    var format = config.moneyFormat || '${{amount}}';
    var value = cents / 100;
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      switch (key) {
        case 'amount_no_decimals':
          return delimit(String(Math.round(value)), ',', '.');
        case 'amount_with_comma_separator':
          return delimit(value.toFixed(2), '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return delimit(String(Math.round(value)), '.', ',');
        case 'amount_with_apostrophe_separator':
          return delimit(value.toFixed(2), "'", '.');
        default:
          return delimit(value.toFixed(2), ',', '.');
      }
    });
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  function digitsHtml(ms) {
    return '<span class="ad-offer-digits">' + formatLeft(ms) + '</span>';
  }

  // Fill [percent], [plant] and [time] in a text setting. [time] becomes the live countdown.
  function fill(template, record, plantLabel, timeHtml) {
    var html = escapeHtml(template || '')
      .replace(/\[percent\]/g, escapeHtml(record.percent))
      .replace(/\[plant\]/g, escapeHtml(plantLabel || ''));
    if (timeHtml) {
      return html.indexOf('[time]') > -1 ? html.replace(/\[time\]/g, timeHtml) : html + ' ' + timeHtml;
    }
    return html.replace(/\s*\[time\]/g, '');
  }

  /* ---------- Cart ---------- */

  var cartQueue = Promise.resolve();

  // Cart changes run one at a time so two updates never overwrite each other.
  function queueCart(task) {
    cartQueue = cartQueue.then(task, task);
    return cartQueue;
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (
      response
    ) {
      return response.json();
    });
  }

  function cartCodes(cart) {
    return ((cart && cart.discount_codes) || []).map(function (discount) {
      return String(discount.code);
    });
  }

  function cartHasCode(cart, code) {
    return cartCodes(cart).some(function (existing) {
      return existing.toUpperCase() === code;
    });
  }

  // Which sections need re-rendering. The theme answers when the drawer is ready; before that,
  // fall back to reading the section ids straight off the cart markup.
  function sectionsToRender() {
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
    );
    if (!sections.length) {
      var drawer = document.querySelector('cart-drawer[data-section-id]');
      if (drawer) sections.push(drawer.getAttribute('data-section-id'));
      Array.prototype.forEach.call(document.querySelectorAll('[id^="MainCart-"]'), function (el) {
        sections.push(el.id.replace('MainCart-', ''));
      });
    }
    return sections.filter(function (id, index, list) {
      return id && list.indexOf(id) === index;
    });
  }

  // Swap in freshly rendered cart drawer / cart page markup, without opening the drawer or moving focus.
  function renderCartSections(sections) {
    Object.keys(sections || {}).forEach(function (id) {
      if (!sections[id]) return;
      var fresh = new DOMParser().parseFromString(sections[id], 'text/html');
      ['CartDrawerBody-', 'CartDrawerFooter-', 'CartDrawerEmpty-', 'MainCart-'].forEach(function (prefix) {
        var current = document.getElementById(prefix + id);
        var next = fresh.getElementById(prefix + id);
        if (current && next) current.innerHTML = next.innerHTML;
      });
    });
  }

  function setCartCodes(codes) {
    var sections = sectionsToRender();
    var body = new FormData();
    body.append('discount', codes.join(','));
    if (sections.length) {
      body.append('sections', sections.join(','));
      body.append('sections_url', window.location.pathname);
    }
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body,
      credentials: 'same-origin',
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        renderCartSections(cart.sections);
        document.dispatchEvent(new CustomEvent('ad-offer:cart-updated', { detail: { cart: cart } }));
        return cart;
      });
  }

  // Always goes through cart/update so the cart markup comes back with the discount on it,
  // even when the code was already saved on the cart from an earlier page.
  function addCode(code) {
    return queueCart(function () {
      return getCart().then(function (cart) {
        var codes = cartCodes(cart);
        if (!cartHasCode(cart, code)) codes = codes.concat(code);
        return setCartCodes(codes);
      });
    });
  }

  function removeCode(code) {
    return queueCart(function () {
      return getCart().then(function (cart) {
        if (!cartHasCode(cart, code)) return cart;
        return setCartCodes(
          cartCodes(cart).filter(function (existing) {
            return existing.toUpperCase() !== code;
          })
        );
      });
    });
  }

  // Is the saving actually drawn anywhere in the cart yet?
  function discountIsShowing() {
    return Boolean(document.querySelector('.cart__discount, .cart-item__discounts .discount'));
  }

  /* ---------- Start, continue or finish an offer ---------- */

  var state = readState();
  var params = new URLSearchParams(window.location.search);
  var requested = (params.get('offer') || '').trim().toUpperCase();
  var arrivedFromAd = Boolean(requested && offers[requested]);
  var startedNow = false;

  if (arrivedFromAd) {
    if (params.has('offer_reset') && isPreview) {
      delete state.offers[requested];
      if (state.active === requested) state.active = null;
    }

    if (!state.offers[requested]) {
      // Only one offer runs at a time: a newer ad click replaces an older countdown.
      var previous = state.active && state.offers[state.active];
      if (previous && !previous.ended) previous.ended = true;

      var offer = offers[requested];
      var plant = offer.product || (pageProduct ? { handle: pageProduct.handle, title: pageProduct.title, url: pageProduct.url } : null);
      state.offers[requested] = {
        code: requested,
        percent: offer.percent,
        product: plant,
        startedAt: now(),
        expiresAt: now() + offer.minutes * 60 * 1000,
        ended: false,
        removed: false,
      };
      state.active = requested;
      startedNow = true;
    } else if (!state.offers[requested].ended && state.offers[requested].expiresAt > now()) {
      state.active = requested;
    }
  }

  // Keep the code out of the address bar once it's been read.
  if (params.has('offer') || params.has('offer_reset')) {
    params.delete('offer');
    params.delete('offer_reset');
    var query = params.toString();
    try {
      window.history.replaceState(window.history.state, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);
    } catch (error) {}
  }

  // Anything that ran out (here or while they were away) comes off the cart once.
  Object.keys(state.offers).forEach(function (code) {
    var record = state.offers[code];
    if (!record || typeof record !== 'object') {
      delete state.offers[code];
      return;
    }
    if (!record.ended && record.expiresAt <= now()) record.ended = true;
    if (record.ended && !record.removed) {
      removeCode(code)
        .then(function () {
          record.removed = true;
          writeState();
        })
        .catch(noop);
    }
  });
  writeState();

  var active = state.active ? state.offers[state.active] : null;
  var running = active && !active.ended && active.expiresAt > now() ? active : null;

  window.RaizAdOffer = {
    state: state,
    reset: function () {
      state = { active: null, offers: {} };
      writeState();
    },
  };

  if (!running) {
    if (arrivedFromAd && state.offers[requested] && state.offers[requested].ended) {
      whenReady(function () {
        mountBar(state.offers[requested]);
        showEnded(state.offers[requested], false);
      });
    }
    return;
  }

  // Wait for the cart markup to exist, otherwise the refreshed cart HTML has nowhere to land.
  whenReady(function () {
    addCode(running.code).catch(noop);
  });

  // If the cart changes (for example the plant gets added), make sure the code is on it and showing.
  if (window.FoxTheme && window.FoxTheme.pubsub && window.FoxTheme.pubsub.subscribe) {
    window.FoxTheme.pubsub.subscribe(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!running || running.ended) return;
      var cart = event && event.cart;
      if (!cart || !cart.items) return;
      var hasPlant =
        !running.product ||
        cart.items.some(function (item) {
          return item.handle === running.product.handle;
        });
      if (!hasPlant) return;
      if (!cartHasCode(cart, running.code) || !discountIsShowing()) {
        addCode(running.code).catch(noop);
      }
    });
  }

  /* ---------- What the shopper sees ---------- */

  function whenReady(callback) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback);
    else callback();
  }

  function onOfferPlantPage(record) {
    return Boolean(pageProduct && record.product && pageProduct.handle === record.product.handle);
  }

  function plantLabel(record) {
    if (!record.product || onOfferPlantPage(record)) return text.thisPlant || 'this plant';
    return record.product.title;
  }

  function mountBar(record) {
    if (ui.bar) return;
    var linkToPlant = Boolean(record.product && !onOfferPlantPage(record));
    var bar = document.createElement(linkToPlant ? 'a' : 'div');
    bar.className = 'ad-offer-bar';
    if (linkToPlant) bar.href = record.product.url;
    bar.innerHTML = '<p class="ad-offer-bar__text"></p>';

    var host = document.querySelector('.announcement-bar');
    if (host) {
      host.classList.add('ad-offer-takeover');
      host.appendChild(bar);
    } else {
      bar.classList.add('ad-offer-bar--standalone');
      var header = document.querySelector('.header-section');
      if (header && header.parentNode) header.parentNode.insertBefore(bar, header.nextSibling);
      else document.body.insertBefore(bar, document.body.firstChild);
    }

    ui.bar = bar;
    ui.barText = bar.firstChild;
  }

  function variantPrice() {
    var prices = (pageProduct && pageProduct.variants) || {};
    var input =
      document.querySelector('.product__block--buy-buttons form[action*="/cart/add"] [name="id"]') ||
      document.querySelector('form[action*="/cart/add"]:not(.installment) [name="id"]');
    var id = input && input.value;
    if (id && prices[id] != null) return prices[id];
    var first = Object.keys(prices)[0];
    return first ? prices[first] : null;
  }

  function offerPrice(cents, percent) {
    return cents - Math.round((cents * percent) / 100);
  }

  function ensureProductUi(record, left) {
    if (!onOfferPlantPage(record)) return;
    document.body.classList.add('ad-offer-on-product');

    var block = document.querySelector('.product__block--price');
    if (!block) return;

    var priceEl = block.querySelector('.ad-offer-pdp-price');
    if (!priceEl) {
      var anchor = block.querySelector('[id^="price-"]');
      anchor = anchor ? anchor.nextSibling : null;

      priceEl = document.createElement('span');
      priceEl.className = 'ad-offer-pdp-price';

      var badge = document.createElement('span');
      badge.className = 'ad-offer-pdp-badge';
      badge.textContent = record.percent + '% OFF';

      var timer = document.createElement('div');
      timer.className = 'ad-offer-pdp-timer';
      timer.innerHTML = CLOCK_SVG + '<span>' + fill(text.product, record, plantLabel(record), digitsHtml(left)) + '</span>';

      block.insertBefore(priceEl, anchor);
      block.insertBefore(badge, anchor);
      block.insertBefore(timer, anchor);
      ui.lastPrice = null;
    }

    var cents = variantPrice();
    if (cents !== ui.lastPrice) {
      ui.lastPrice = cents;
      priceEl.textContent = cents == null ? '' : formatMoney(offerPrice(cents, record.percent));
    }
  }

  function removeProductUi() {
    document.body.classList.remove('ad-offer-on-product');
    document.querySelectorAll('.ad-offer-pdp-price, .ad-offer-pdp-badge, .ad-offer-pdp-timer').forEach(function (el) {
      el.remove();
    });
  }

  // Only show the cart timer when the plant is actually in the cart.
  function cartHasPlant(container, record) {
    if (!record.product) return true;
    var handle = record.product.handle;
    if (container.querySelector('[id^="CartDrawer-Item-"][data-handle="' + handle + '"]')) return true;
    return Array.prototype.some.call(container.querySelectorAll('[id^="CartItem-"] a[href*="/products/"]'), function (link) {
      return link.pathname.split('/products/')[1] === handle;
    });
  }

  function ensureCartUi(record, left, ended) {
    document.querySelectorAll('button[name="checkout"]').forEach(function (button) {
      var target =
        button.closest('.drawer__footer-buttons') || button.closest('.cart__footer--buttons') || button.closest('form') || button.parentElement;
      if (!target || !target.parentNode) return;

      var container = button.closest('cart-drawer') || button.closest('.cart') || document;
      var existing = target.previousElementSibling && target.previousElementSibling.classList.contains('ad-offer-cart') ? target.previousElementSibling : null;

      if (!cartHasPlant(container, record)) {
        if (existing) existing.remove();
        return;
      }

      var mode = ended ? 'ended' : 'running';
      if (existing && existing.getAttribute('data-mode') === mode) return;
      if (existing) existing.remove();

      var chip = document.createElement('div');
      chip.className = 'ad-offer-cart' + (ended ? ' ad-offer-cart--ended' : '') + (target.classList.contains('cart__footer--buttons') ? ' ad-offer-cart--page' : '');
      chip.setAttribute('data-mode', mode);
      chip.innerHTML = ended
        ? '<span>' + fill(text.cartEnded, record, plantLabel(record), '') + '</span>'
        : CLOCK_SVG + '<span>' + fill(text.cart, record, plantLabel(record), digitsHtml(left)) + '</span>';
      target.parentNode.insertBefore(chip, target);
    });
  }

  function updateDigits(left) {
    var label = formatLeft(left);
    if (label !== ui.lastLabel) {
      ui.lastLabel = label;
      document.querySelectorAll('.ad-offer-digits').forEach(function (el) {
        el.textContent = label;
      });
    }
    var urgent = left <= URGENT_MS;
    if (urgent !== ui.urgent && ui.bar) {
      ui.urgent = urgent;
      ui.bar.classList.toggle('ad-offer-urgent', urgent);
    }
  }

  function showRunning(record) {
    var left = record.expiresAt - now();
    mountBar(record);
    ui.barText.innerHTML = fill(text.bar, record, plantLabel(record), '<span class="ad-offer-time">' + digitsHtml(left) + '</span>');
    ui.lastLabel = formatLeft(left);
    tick();
    ui.timer = window.setInterval(tick, TICK_MS);
  }

  function showEnded(record, justEnded) {
    if (ui.timer) window.clearInterval(ui.timer);
    ui.timer = null;
    removeProductUi();
    if (ui.bar) {
      ui.bar.classList.remove('ad-offer-urgent');
      ui.barText.innerHTML = escapeHtml(text.ended || 'This offer has ended');
    }
    if (justEnded) {
      document.querySelectorAll('.ad-offer-cart').forEach(function (el) {
        el.remove();
      });
    }
  }

  function finish() {
    var record = running;
    running = null;
    record.ended = true;
    writeState();
    showEnded(record, true);
    removeCode(record.code)
      .then(function () {
        record.removed = true;
        writeState();
        // The cart now shows full price, so say why next to the checkout button.
        ensureCartUi(record, 0, true);
      })
      .catch(noop);
  }

  function tick() {
    if (!running) return;
    var left = running.expiresAt - now();
    if (left <= 0) {
      finish();
      return;
    }
    ensureProductUi(running, left);
    ensureCartUi(running, left, false);
    updateDigits(left);
  }

  whenReady(function () {
    if (running) showRunning(running);
  });
})();
